'use client';

import Spinner from '@carvana/ds-spinner';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect } from 'react';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';

export default function Loader() {
  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    trackEvent(ANALYTICS_EVENTS.LOADER.PAGE_RENDERED);
  }, [trackEvent]);

  return (
    <div className="flex h-[100dvh] items-center justify-center">
      <Spinner size={57} />
    </div>
  );
}
